export const translations = {
  it: {
    nav: {
      home: 'Home',
      forChefs: 'Per Pizzaioli',
      forRestaurants: 'Per Ristoratori',
      about: 'Chi Siamo',
      contact: 'Contatti',
      admin: 'Admin'
    },
    hero: {
      title: 'Il Network Internazionale',
      titleAccent: 'dei Pizzaioli',
      subtitle: 'Connettiamo talenti dell\'arte bianca con le migliori pizzerie d\'Europa. Selezione professionale, opportunità internazionali.',
      ctaChef: 'Candidati Ora',
      ctaRestaurant: 'Scopri i Talenti'
    },
    services: {
      title: 'I Nostri Servizi',
      subtitle: 'Un approccio premium alla selezione del personale',
      matching: {
        title: 'Matching Perfetto',
        desc: 'Selezione manuale e tecnica del pizzaiolo ideale per il concept del tuo locale.'
      },
      mentoring: {
        title: 'Mentoring',
        desc: 'Formazione pratica per aspiranti pizzaioli direttamente sul campo.'
      },
      consulting: {
        title: 'Consulenza',
        desc: 'Supporto tecnico per l\'apertura di nuove pizzerie.'
      }
    },
    about: {
      title: 'Chi Sono',
      subtitle: 'La Mia Storia',
      intro: 'Mi chiamo Giacomo, pizzaiolo con oltre 12 anni di esperienza internazionale.',
      experience: 'Ho lavorato nelle migliori pizzerie di Italia, Isole Canarie, Francia, Germania, Portogallo, Malta, Paesi Bassi e Svezia. Unisco la cucina gourmet con l\'arte bianca, specializzandomi in fermentazioni, impasti contemporanei e pizza romana croccante.',
      mission: 'La mia missione è filtrare il mercato per garantire che ogni locale trovi il talento giusto e ogni pizzaiolo trovi una struttura che lo valorizzi.',
      cta: 'Scopri di più',
      valuesTitle: 'I Nostri Valori',
      valuesSubtitle: 'Cosa ci rende diversi da una semplice agenzia',
      value1Title: 'Selezione Premium',
      value1Desc: 'Non siamo un\'agenzia interinale. Selezioniamo personalmente ogni candidato.',
      value2Title: 'Network Internazionale',
      value2Desc: 'Connessioni in tutta Europa con le migliori pizzerie del continente.',
      value3Title: 'Esperienza Reale',
      value3Desc: '12+ anni nel settore pizza. Capiamo le esigenze di pizzerie e pizzaioli.',
      filterTitle: 'Il Filtro',
      filterTitleAccent: 'Tecnico',
      filterDesc1: 'A differenza delle agenzie tradizionali, io capisco veramente il mestiere del pizzaiolo. So valutare la qualità di un impasto, la gestione di un forno a legna, la capacità di lavorare sotto pressione durante il servizio.',
      filterDesc2: 'Questo mi permette di selezionare candidati che non solo hanno l\'esperienza sulla carta, ma che sanno veramente fare il loro lavoro.',
      filterPoint1: 'Esperto di fermentazioni e impasti contemporanei',
      filterPoint2: 'Specializzato in pizza romana croccante',
      filterPoint3: 'Conoscenza norme igieniche internazionali',
      filterPoint4: 'Unione tra cucina gourmet e arte bianca',
      servicesTitle: 'Servizi Offerti',
      service1Title: 'Matching Perfetto',
      service1Desc: 'Selezione manuale e tecnica del pizzaiolo ideale per il concept del tuo locale.',
      service2Title: 'Mentoring in Ristorante',
      service2Desc: 'Formazione pratica per aspiranti pizzaioli direttamente sul campo.',
      service3Title: 'Consulenza Start-up',
      service3Desc: 'Supporto tecnico per l\'apertura di nuove pizzerie.',
      service4Title: 'Percorso New Talent',
      service4Desc: 'Formazione teorica per chi vuole entrare nel settore.',
      ctaTitle: 'Pronto a',
      ctaTitleAccent: 'Iniziare',
      ctaDesc: 'Che tu sia un pizzaiolo in cerca di nuove opportunità o un ristoratore alla ricerca del talento perfetto, sono qui per aiutarti.',
      ctaChef: 'Sono un Pizzaiolo',
      ctaRestaurant: 'Sono un Ristoratore',
      transparencyTitle: 'Trasparenza',
      transparencySubtitle: 'Come Funziona il Servizio',
      transparency1Title: 'Intermediazione Professionale',
      transparency1Desc: 'Lavoro come intermediario tra pizzaioli e ristoratori, facilitando la connessione tra domanda e offerta.',
      transparency2Title: 'Profili Anonimi Iniziali',
      transparency2Desc: 'I profili dei candidati vengono presentati in forma anonima fino alla firma del contratto di mediazione.',
      transparency3Title: 'Pagamento Prima del Contatto',
      transparency3Desc: 'Il pagamento della commissione avviene prima di ricevere i contatti diretti del candidato selezionato.',
      transparency4Title: 'Fattura Inclusa',
      transparency4Desc: 'Ogni transazione include regolare fattura per la trasparenza fiscale della tua azienda.',
      transparency5Title: 'Nessuna Gestione Contratti',
      transparency5Desc: 'Non gestiamo contratti di lavoro. Il rapporto lavorativo è diretto tra ristoratore e pizzaiolo.'
    },
    howItWorks: {
      title: 'Come Funziona',
      subtitle: 'Un processo semplice e professionale',
      step1: {
        title: 'Registrazione',
        desc: 'Il pizzaiolo compila il form con esperienza, specializzazioni e disponibilità.'
      },
      step2: {
        title: 'Richiesta',
        desc: 'Il ristoratore invia la sua richiesta specificando le esigenze.'
      },
      step3: {
        title: 'Selezione',
        desc: 'Analizzo le richieste e propongo 1-2 profili selezionati.'
      },
      step4: {
        title: 'Connessione',
        desc: 'Dopo il contratto, condivido i contatti diretti.'
      }
    },
    chefForm: {
      title: 'Candidatura Pizzaiolo',
      subtitle: 'Compila il form per entrare nel nostro network',
      section1: 'Informazioni Personali',
      section2: 'Esperienza',
      section3: 'Lingue e Disponibilità',
      section4: 'Presentazione e CV',
      name: 'Nome Completo',
      email: 'Email',
      phone: 'Telefono',
      experience: 'Anni di Esperienza',
      pizzaTypes: 'Tipi di Pizza',
      ovenTypes: 'Tipi di Forno',
      languages: 'Lingue Parlate',
      countries: 'Paesi Disponibilità',
      currentCountry: 'Paese Attuale',
      bio: 'Presentazione',
      bioPlaceholder: 'Raccontaci la tua esperienza e le tue specializzazioni...',
      cv: 'Curriculum Vitae',
      cvUpload: 'Carica il tuo CV',
      cvFormats: 'Formati accettati: PDF, DOC, DOCX (max 5MB)',
      cvUploaded: 'CV caricato',
      submit: 'Invia Candidatura',
      success: 'Candidatura inviata con successo!',
      error: 'Errore durante l\'invio'
    },
    restaurantForm: {
      title: 'Richiesta Personale',
      subtitle: 'Descrivi il pizzaiolo che stai cercando',
      section1: 'Informazioni Ristorante',
      section2: 'Requisiti',
      section3: 'Condizioni',
      restaurantName: 'Nome Ristorante',
      contactName: 'Nome Referente',
      email: 'Email',
      phone: 'Telefono',
      country: 'Paese',
      city: 'Città',
      pizzaType: 'Tipo Pizza Richiesta',
      ovenType: 'Tipo Forno',
      experience: 'Esperienza Richiesta',
      salary: 'Range Salariale',
      accommodation: 'Alloggio Disponibile',
      urgency: 'Urgenza',
      notes: 'Note Aggiuntive',
      submit: 'Invia Richiesta',
      success: 'Richiesta inviata con successo!',
      error: 'Errore durante l\'invio'
    },
    footer: {
      tagline: 'Il network internazionale dei pizzaioli professionisti',
      quickLinks: 'Link Rapidi',
      contact: 'Contatti',
      legal: 'Legale',
      privacy: 'Privacy Policy',
      terms: 'Termini di Servizio',
      rights: 'Tutti i diritti riservati'
    },
    experienceLevels: {
      '0-1': 'Principiante (0-1 anni)',
      '1-2': 'Junior (1-2 anni)',
      '2-5': 'Intermedio (2-5 anni)',
      '5-10': 'Esperto (5-10 anni)',
      '10+': 'Master (10+ anni)'
    },
    pizzaTypes: {
      napoletana: 'Napoletana',
      romana: 'Romana',
      contemporanea: 'Contemporanea',
      teglia: 'Teglia',
      pinsa: 'Pinsa'
    },
    ovenTypes: {
      legna: 'Forno a Legna',
      gas: 'Forno a Gas',
      elettrico: 'Forno Elettrico',
      misto: 'Forno Misto'
    },
    urgencyLevels: {
      immediate: 'Immediata',
      '1month': 'Entro 1 mese',
      '3months': 'Entro 3 mesi',
      flexible: 'Flessibile'
    },
    countries: {
      all_europe: 'Tutta Europa',
      italy: 'Italia',
      france: 'Francia',
      germany: 'Germania',
      switzerland: 'Svizzera',
      spain: 'Spagna',
      uk: 'Regno Unito',
      netherlands: 'Paesi Bassi',
      belgium: 'Belgio',
      austria: 'Austria',
      sweden: 'Svezia'
    },
    languages: {
      italian: 'Italiano',
      english: 'Inglese',
      french: 'Francese',
      spanish: 'Spagnolo',
      german: 'Tedesco',
      portuguese: 'Portoghese'
    }
  },
  en: {
    nav: {
      home: 'Home',
      forChefs: 'For Chefs',
      forRestaurants: 'For Restaurants',
      about: 'About',
      contact: 'Contact',
      admin: 'Admin'
    },
    hero: {
      title: 'The International Network',
      titleAccent: 'of Pizza Chefs',
      subtitle: 'Connecting pizza artisans with Europe\'s finest pizzerias. Professional selection, international opportunities.',
      ctaChef: 'Apply Now',
      ctaRestaurant: 'Discover Talents'
    },
    services: {
      title: 'Our Services',
      subtitle: 'A premium approach to talent selection',
      matching: {
        title: 'Perfect Matching',
        desc: 'Manual and technical selection of the ideal pizza chef for your concept.'
      },
      mentoring: {
        title: 'Mentoring',
        desc: 'Hands-on training for aspiring pizza chefs directly in the field.'
      },
      consulting: {
        title: 'Consulting',
        desc: 'Technical support for opening new pizzerias.'
      }
    },
    about: {
      title: 'About Me',
      subtitle: 'My Story',
      intro: 'My name is Giacomo, a pizza chef with over 12 years of international experience.',
      experience: 'I have worked in the best pizzerias in Italy, Canary Islands, France, Germany, Portugal, Malta, Netherlands, and Sweden. I combine gourmet cuisine with pizza artistry, specializing in fermentation, contemporary doughs, and crispy Roman pizza.',
      mission: 'My mission is to filter the market to ensure every establishment finds the right talent and every pizza chef finds a structure that values them.',
      cta: 'Learn More',
      valuesTitle: 'Our Values',
      valuesSubtitle: 'What makes us different from a simple agency',
      value1Title: 'Premium Selection',
      value1Desc: 'We are not a temp agency. We personally select every candidate.',
      value2Title: 'International Network',
      value2Desc: 'Connections across Europe with the best pizzerias on the continent.',
      value3Title: 'Real Experience',
      value3Desc: '12+ years in the pizza industry. We understand the needs of pizzerias and pizza chefs.',
      filterTitle: 'The Technical',
      filterTitleAccent: 'Filter',
      filterDesc1: 'Unlike traditional agencies, I truly understand the pizza chef profession. I can evaluate the quality of a dough, the management of a wood-fired oven, the ability to work under pressure during service.',
      filterDesc2: 'This allows me to select candidates who not only have experience on paper but who truly know how to do their job.',
      filterPoint1: 'Expert in fermentation and contemporary doughs',
      filterPoint2: 'Specialized in crispy Roman pizza',
      filterPoint3: 'Knowledge of international hygiene standards',
      filterPoint4: 'Union of gourmet cuisine and pizza artistry',
      servicesTitle: 'Services Offered',
      service1Title: 'Perfect Matching',
      service1Desc: 'Manual and technical selection of the ideal pizza chef for your concept.',
      service2Title: 'Restaurant Mentoring',
      service2Desc: 'Hands-on training for aspiring pizza chefs directly in the field.',
      service3Title: 'Start-up Consulting',
      service3Desc: 'Technical support for opening new pizzerias.',
      service4Title: 'New Talent Path',
      service4Desc: 'Theoretical training for those who want to enter the industry.',
      ctaTitle: 'Ready to',
      ctaTitleAccent: 'Start',
      ctaDesc: 'Whether you are a pizza chef looking for new opportunities or a restaurant owner looking for the perfect talent, I am here to help.',
      ctaChef: 'I am a Pizza Chef',
      ctaRestaurant: 'I am a Restaurant Owner',
      transparencyTitle: 'Transparency',
      transparencySubtitle: 'How the Service Works',
      transparency1Title: 'Professional Mediation',
      transparency1Desc: 'I work as an intermediary between pizza chefs and restaurant owners, facilitating the connection between supply and demand.',
      transparency2Title: 'Initial Anonymous Profiles',
      transparency2Desc: 'Candidate profiles are presented anonymously until the mediation contract is signed.',
      transparency3Title: 'Payment Before Contact',
      transparency3Desc: 'The commission payment is made before receiving the direct contacts of the selected candidate.',
      transparency4Title: 'Invoice Included',
      transparency4Desc: 'Every transaction includes a proper invoice for your company\'s tax transparency.',
      transparency5Title: 'No Employment Contract Management',
      transparency5Desc: 'We do not manage employment contracts. The working relationship is direct between the restaurant owner and the pizza chef.'
    },
    howItWorks: {
      title: 'How It Works',
      subtitle: 'A simple and professional process',
      step1: {
        title: 'Registration',
        desc: 'The pizza chef fills out the form with experience, specializations, and availability.'
      },
      step2: {
        title: 'Request',
        desc: 'The restaurant owner sends their request specifying needs.'
      },
      step3: {
        title: 'Selection',
        desc: 'I analyze requests and propose 1-2 selected profiles.'
      },
      step4: {
        title: 'Connection',
        desc: 'After the contract, I share direct contacts.'
      }
    },
    chefForm: {
      title: 'Chef Application',
      subtitle: 'Fill out the form to join our network',
      section1: 'Personal Information',
      section2: 'Experience',
      section3: 'Languages and Availability',
      section4: 'Introduction and CV',
      name: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      experience: 'Years of Experience',
      pizzaTypes: 'Pizza Types',
      ovenTypes: 'Oven Types',
      languages: 'Languages Spoken',
      countries: 'Available Countries',
      currentCountry: 'Current Country',
      bio: 'Introduction',
      bioPlaceholder: 'Tell us about your experience and specializations...',
      cv: 'Curriculum Vitae',
      cvUpload: 'Upload your CV',
      cvFormats: 'Accepted formats: PDF, DOC, DOCX (max 5MB)',
      cvUploaded: 'CV uploaded',
      submit: 'Submit Application',
      success: 'Application submitted successfully!',
      error: 'Error during submission'
    },
    restaurantForm: {
      title: 'Staff Request',
      subtitle: 'Describe the pizza chef you are looking for',
      section1: 'Restaurant Information',
      section2: 'Requirements',
      section3: 'Conditions',
      restaurantName: 'Restaurant Name',
      contactName: 'Contact Person',
      email: 'Email',
      phone: 'Phone',
      country: 'Country',
      city: 'City',
      pizzaType: 'Pizza Type Required',
      ovenType: 'Oven Type',
      experience: 'Experience Required',
      salary: 'Salary Range',
      accommodation: 'Accommodation Available',
      urgency: 'Urgency',
      notes: 'Additional Notes',
      submit: 'Submit Request',
      success: 'Request submitted successfully!',
      error: 'Error during submission'
    },
    footer: {
      tagline: 'The international network of professional pizza chefs',
      quickLinks: 'Quick Links',
      contact: 'Contact',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      rights: 'All rights reserved'
    },
    experienceLevels: {
      '0-1': 'Beginner (0-1 years)',
      '1-2': 'Junior (1-2 years)',
      '2-5': 'Intermediate (2-5 years)',
      '5-10': 'Expert (5-10 years)',
      '10+': 'Master (10+ years)'
    },
    pizzaTypes: {
      napoletana: 'Neapolitan',
      romana: 'Roman',
      contemporanea: 'Contemporary',
      teglia: 'Pan Pizza',
      pinsa: 'Pinsa'
    },
    ovenTypes: {
      legna: 'Wood-Fired Oven',
      gas: 'Gas Oven',
      elettrico: 'Electric Oven',
      misto: 'Mixed Oven'
    },
    urgencyLevels: {
      immediate: 'Immediate',
      '1month': 'Within 1 month',
      '3months': 'Within 3 months',
      flexible: 'Flexible'
    },
    countries: {
      all_europe: 'All Europe',
      italy: 'Italy',
      france: 'France',
      germany: 'Germany',
      switzerland: 'Switzerland',
      spain: 'Spain',
      uk: 'United Kingdom',
      netherlands: 'Netherlands',
      belgium: 'Belgium',
      austria: 'Austria',
      sweden: 'Sweden'
    },
    languages: {
      italian: 'Italian',
      english: 'English',
      french: 'French',
      spanish: 'Spanish',
      german: 'German',
      portuguese: 'Portuguese'
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      forChefs: 'Pour Pizzaïolos',
      forRestaurants: 'Pour Restaurants',
      about: 'À Propos',
      contact: 'Contact',
      admin: 'Admin'
    },
    hero: {
      title: 'Le Réseau International',
      titleAccent: 'des Pizzaïolos',
      subtitle: 'Connecter les artisans de la pizza avec les meilleures pizzerias d\'Europe. Sélection professionnelle, opportunités internationales.',
      ctaChef: 'Postuler',
      ctaRestaurant: 'Découvrir les Talents'
    },
    services: {
      title: 'Nos Services',
      subtitle: 'Une approche premium de la sélection',
      matching: {
        title: 'Matching Parfait',
        desc: 'Sélection manuelle et technique du pizzaïolo idéal pour votre concept.'
      },
      mentoring: {
        title: 'Mentorat',
        desc: 'Formation pratique pour les aspirants pizzaïolos directement sur le terrain.'
      },
      consulting: {
        title: 'Conseil',
        desc: 'Support technique pour l\'ouverture de nouvelles pizzerias.'
      }
    },
    about: {
      title: 'Qui Suis-Je',
      subtitle: 'Mon Histoire',
      intro: 'Je m\'appelle Giacomo, pizzaïolo avec plus de 12 ans d\'expérience internationale.',
      experience: 'J\'ai travaillé dans les meilleures pizzerias en Italie, aux Îles Canaries, en France, en Allemagne, au Portugal, à Malte, aux Pays-Bas et en Suède. Je combine la cuisine gastronomique avec l\'art de la pizza.',
      mission: 'Ma mission est de filtrer le marché pour garantir que chaque établissement trouve le bon talent.',
      cta: 'En Savoir Plus',
      valuesTitle: 'Nos Valeurs',
      valuesSubtitle: 'Ce qui nous différencie d\'une simple agence',
      value1Title: 'Sélection Premium',
      value1Desc: 'Nous ne sommes pas une agence d\'intérim. Nous sélectionnons personnellement chaque candidat.',
      value2Title: 'Réseau International',
      value2Desc: 'Connexions à travers l\'Europe avec les meilleures pizzerias du continent.',
      value3Title: 'Expérience Réelle',
      value3Desc: '12+ ans dans le secteur pizza. Nous comprenons les besoins des pizzerias et pizzaïolos.',
      filterTitle: 'Le Filtre',
      filterTitleAccent: 'Technique',
      filterDesc1: 'Contrairement aux agences traditionnelles, je comprends vraiment le métier de pizzaïolo. Je sais évaluer la qualité d\'une pâte, la gestion d\'un four à bois, la capacité à travailler sous pression.',
      filterDesc2: 'Cela me permet de sélectionner des candidats qui ont non seulement l\'expérience sur le papier, mais qui savent vraiment faire leur travail.',
      filterPoint1: 'Expert en fermentations et pâtes contemporaines',
      filterPoint2: 'Spécialisé en pizza romaine croustillante',
      filterPoint3: 'Connaissance des normes d\'hygiène internationales',
      filterPoint4: 'Union de la cuisine gastronomique et de l\'art de la pizza',
      servicesTitle: 'Services Offerts',
      service1Title: 'Matching Parfait',
      service1Desc: 'Sélection manuelle et technique du pizzaïolo idéal pour votre concept.',
      service2Title: 'Mentorat en Restaurant',
      service2Desc: 'Formation pratique pour aspirants pizzaïolos directement sur le terrain.',
      service3Title: 'Conseil Start-up',
      service3Desc: 'Support technique pour l\'ouverture de nouvelles pizzerias.',
      service4Title: 'Parcours New Talent',
      service4Desc: 'Formation théorique pour ceux qui veulent entrer dans le secteur.',
      ctaTitle: 'Prêt à',
      ctaTitleAccent: 'Commencer',
      ctaDesc: 'Que vous soyez un pizzaïolo à la recherche de nouvelles opportunités ou un restaurateur à la recherche du talent parfait, je suis là pour vous aider.',
      ctaChef: 'Je suis Pizzaïolo',
      ctaRestaurant: 'Je suis Restaurateur',
      transparencyTitle: 'Transparence',
      transparencySubtitle: 'Comment Fonctionne le Service',
      transparency1Title: 'Médiation Professionnelle',
      transparency1Desc: 'Je travaille comme intermédiaire entre pizzaïolos et restaurateurs, facilitant la connexion entre l\'offre et la demande.',
      transparency2Title: 'Profils Anonymes Initiaux',
      transparency2Desc: 'Les profils des candidats sont présentés de manière anonyme jusqu\'à la signature du contrat de médiation.',
      transparency3Title: 'Paiement Avant Contact',
      transparency3Desc: 'Le paiement de la commission se fait avant de recevoir les contacts directs du candidat sélectionné.',
      transparency4Title: 'Facture Incluse',
      transparency4Desc: 'Chaque transaction comprend une facture régulière pour la transparence fiscale de votre entreprise.',
      transparency5Title: 'Pas de Gestion des Contrats',
      transparency5Desc: 'Nous ne gérons pas les contrats de travail. La relation de travail est directe entre le restaurateur et le pizzaïolo.'
    },
    howItWorks: {
      title: 'Comment Ça Marche',
      subtitle: 'Un processus simple et professionnel',
      step1: {
        title: 'Inscription',
        desc: 'Le pizzaïolo remplit le formulaire avec expérience et disponibilités.'
      },
      step2: {
        title: 'Demande',
        desc: 'Le restaurateur envoie sa demande en spécifiant ses besoins.'
      },
      step3: {
        title: 'Sélection',
        desc: 'J\'analyse les demandes et propose 1-2 profils sélectionnés.'
      },
      step4: {
        title: 'Connexion',
        desc: 'Après le contrat, je partage les contacts directs.'
      }
    },
    chefForm: {
      title: 'Candidature Pizzaïolo',
      subtitle: 'Remplissez le formulaire pour rejoindre notre réseau',
      section1: 'Informations Personnelles',
      section2: 'Expérience',
      section3: 'Langues et Disponibilité',
      section4: 'Présentation et CV',
      name: 'Nom Complet',
      email: 'Email',
      phone: 'Téléphone',
      experience: 'Années d\'Expérience',
      pizzaTypes: 'Types de Pizza',
      ovenTypes: 'Types de Four',
      languages: 'Langues Parlées',
      countries: 'Pays Disponibles',
      currentCountry: 'Pays Actuel',
      bio: 'Présentation',
      bioPlaceholder: 'Parlez-nous de votre expérience...',
      cv: 'Curriculum Vitae',
      cvUpload: 'Téléchargez votre CV',
      cvFormats: 'Formats acceptés: PDF, DOC, DOCX (max 5MB)',
      cvUploaded: 'CV téléchargé',
      submit: 'Envoyer',
      success: 'Candidature envoyée avec succès!',
      error: 'Erreur lors de l\'envoi'
    },
    restaurantForm: {
      title: 'Demande de Personnel',
      subtitle: 'Décrivez le pizzaïolo que vous recherchez',
      section1: 'Informations Restaurant',
      section2: 'Exigences',
      section3: 'Conditions',
      restaurantName: 'Nom du Restaurant',
      contactName: 'Personne de Contact',
      email: 'Email',
      phone: 'Téléphone',
      country: 'Pays',
      city: 'Ville',
      pizzaType: 'Type de Pizza',
      ovenType: 'Type de Four',
      experience: 'Expérience Requise',
      salary: 'Fourchette Salariale',
      accommodation: 'Logement Disponible',
      urgency: 'Urgence',
      notes: 'Notes',
      submit: 'Envoyer',
      success: 'Demande envoyée avec succès!',
      error: 'Erreur lors de l\'envoi'
    },
    footer: {
      tagline: 'Le réseau international des pizzaïolos professionnels',
      quickLinks: 'Liens Rapides',
      contact: 'Contact',
      legal: 'Légal',
      privacy: 'Politique de Confidentialité',
      terms: 'Conditions d\'Utilisation',
      rights: 'Tous droits réservés'
    },
    experienceLevels: {
      '0-1': 'Débutant (0-1 ans)',
      '1-2': 'Junior (1-2 ans)',
      '2-5': 'Intermédiaire (2-5 ans)',
      '5-10': 'Expert (5-10 ans)',
      '10+': 'Maître (10+ ans)'
    },
    pizzaTypes: {
      napoletana: 'Napolitaine',
      romana: 'Romaine',
      contemporanea: 'Contemporaine',
      teglia: 'Teglia',
      pinsa: 'Pinsa'
    },
    ovenTypes: {
      legna: 'Four à Bois',
      gas: 'Four à Gaz',
      elettrico: 'Four Électrique',
      misto: 'Four Mixte'
    },
    urgencyLevels: {
      immediate: 'Immédiate',
      '1month': 'Sous 1 mois',
      '3months': 'Sous 3 mois',
      flexible: 'Flexible'
    },
    countries: {
      all_europe: 'Toute l\'Europe',
      italy: 'Italie',
      france: 'France',
      germany: 'Allemagne',
      switzerland: 'Suisse',
      spain: 'Espagne',
      uk: 'Royaume-Uni',
      netherlands: 'Pays-Bas',
      belgium: 'Belgique',
      austria: 'Autriche',
      sweden: 'Suède'
    },
    languages: {
      italian: 'Italien',
      english: 'Anglais',
      french: 'Français',
      spanish: 'Espagnol',
      german: 'Allemand',
      portuguese: 'Portugais'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      forChefs: 'Para Pizzeros',
      forRestaurants: 'Para Restaurantes',
      about: 'Nosotros',
      contact: 'Contacto',
      admin: 'Admin'
    },
    hero: {
      title: 'La Red Internacional',
      titleAccent: 'de Pizzeros',
      subtitle: 'Conectando artesanos de la pizza con las mejores pizzerías de Europa. Selección profesional, oportunidades internacionales.',
      ctaChef: 'Aplicar Ahora',
      ctaRestaurant: 'Descubrir Talentos'
    },
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Un enfoque premium para la selección de talento',
      matching: {
        title: 'Matching Perfecto',
        desc: 'Selección manual y técnica del pizzero ideal para tu concepto.'
      },
      mentoring: {
        title: 'Mentoría',
        desc: 'Formación práctica para aspirantes a pizzero directamente en el campo.'
      },
      consulting: {
        title: 'Consultoría',
        desc: 'Soporte técnico para la apertura de nuevas pizzerías.'
      }
    },
    about: {
      title: 'Sobre Mí',
      subtitle: 'Mi Historia',
      intro: 'Me llamo Giacomo, pizzero con más de 12 años de experiencia internacional.',
      experience: 'He trabajado en las mejores pizzerías de Italia, Islas Canarias, Francia, Alemania, Portugal, Malta, Países Bajos y Suecia. Combino la cocina gourmet con el arte de la pizza.',
      mission: 'Mi misión es filtrar el mercado para garantizar que cada establecimiento encuentre el talento adecuado.',
      cta: 'Saber Más',
      valuesTitle: 'Nuestros Valores',
      valuesSubtitle: 'Lo que nos diferencia de una simple agencia',
      value1Title: 'Selección Premium',
      value1Desc: 'No somos una agencia de empleo temporal. Seleccionamos personalmente a cada candidato.',
      value2Title: 'Red Internacional',
      value2Desc: 'Conexiones en toda Europa con las mejores pizzerías del continente.',
      value3Title: 'Experiencia Real',
      value3Desc: '12+ años en el sector pizza. Entendemos las necesidades de pizzerías y pizzeros.',
      filterTitle: 'El Filtro',
      filterTitleAccent: 'Técnico',
      filterDesc1: 'A diferencia de las agencias tradicionales, yo entiendo realmente el oficio del pizzero. Sé evaluar la calidad de una masa, la gestión de un horno de leña, la capacidad de trabajar bajo presión.',
      filterDesc2: 'Esto me permite seleccionar candidatos que no solo tienen experiencia en papel, sino que realmente saben hacer su trabajo.',
      filterPoint1: 'Experto en fermentaciones y masas contemporáneas',
      filterPoint2: 'Especializado en pizza romana crujiente',
      filterPoint3: 'Conocimiento de normas higiénicas internacionales',
      filterPoint4: 'Unión de cocina gourmet y arte de la pizza',
      servicesTitle: 'Servicios Ofrecidos',
      service1Title: 'Matching Perfecto',
      service1Desc: 'Selección manual y técnica del pizzero ideal para tu concepto.',
      service2Title: 'Mentoría en Restaurante',
      service2Desc: 'Formación práctica para aspirantes a pizzero directamente en el campo.',
      service3Title: 'Consultoría Start-up',
      service3Desc: 'Soporte técnico para la apertura de nuevas pizzerías.',
      service4Title: 'Ruta New Talent',
      service4Desc: 'Formación teórica para quienes quieren entrar en el sector.',
      ctaTitle: '¿Listo para',
      ctaTitleAccent: 'Empezar',
      ctaDesc: 'Ya seas un pizzero buscando nuevas oportunidades o un restaurador buscando el talento perfecto, estoy aquí para ayudarte.',
      ctaChef: 'Soy Pizzero',
      ctaRestaurant: 'Soy Restaurador',
      transparencyTitle: 'Transparencia',
      transparencySubtitle: 'Cómo Funciona el Servicio',
      transparency1Title: 'Intermediación Profesional',
      transparency1Desc: 'Trabajo como intermediario entre pizzeros y restauradores, facilitando la conexión entre oferta y demanda.',
      transparency2Title: 'Perfiles Anónimos Iniciales',
      transparency2Desc: 'Los perfiles de los candidatos se presentan de forma anónima hasta la firma del contrato de mediación.',
      transparency3Title: 'Pago Antes del Contacto',
      transparency3Desc: 'El pago de la comisión se realiza antes de recibir los contactos directos del candidato seleccionado.',
      transparency4Title: 'Factura Incluida',
      transparency4Desc: 'Cada transacción incluye factura regular para la transparencia fiscal de tu empresa.',
      transparency5Title: 'Sin Gestión de Contratos',
      transparency5Desc: 'No gestionamos contratos de trabajo. La relación laboral es directa entre el restaurador y el pizzero.'
    },
    howItWorks: {
      title: 'Cómo Funciona',
      subtitle: 'Un proceso simple y profesional',
      step1: {
        title: 'Registro',
        desc: 'El pizzero completa el formulario con experiencia y disponibilidad.'
      },
      step2: {
        title: 'Solicitud',
        desc: 'El restaurador envía su solicitud especificando necesidades.'
      },
      step3: {
        title: 'Selección',
        desc: 'Analizo las solicitudes y propongo 1-2 perfiles seleccionados.'
      },
      step4: {
        title: 'Conexión',
        desc: 'Después del contrato, comparto los contactos directos.'
      }
    },
    chefForm: {
      title: 'Candidatura Pizzero',
      subtitle: 'Completa el formulario para unirte a nuestra red',
      section1: 'Información Personal',
      section2: 'Experiencia',
      section3: 'Idiomas y Disponibilidad',
      section4: 'Presentación y CV',
      name: 'Nombre Completo',
      email: 'Email',
      phone: 'Teléfono',
      experience: 'Años de Experiencia',
      pizzaTypes: 'Tipos de Pizza',
      ovenTypes: 'Tipos de Horno',
      languages: 'Idiomas',
      countries: 'Países Disponibles',
      currentCountry: 'País Actual',
      bio: 'Presentación',
      bioPlaceholder: 'Cuéntanos tu experiencia...',
      cv: 'Curriculum Vitae',
      cvUpload: 'Sube tu CV',
      cvFormats: 'Formatos aceptados: PDF, DOC, DOCX (max 5MB)',
      cvUploaded: 'CV subido',
      submit: 'Enviar',
      success: '¡Candidatura enviada con éxito!',
      error: 'Error durante el envío'
    },
    restaurantForm: {
      title: 'Solicitud de Personal',
      subtitle: 'Describe al pizzero que buscas',
      section1: 'Información del Restaurante',
      section2: 'Requisitos',
      section3: 'Condiciones',
      restaurantName: 'Nombre del Restaurante',
      contactName: 'Persona de Contacto',
      email: 'Email',
      phone: 'Teléfono',
      country: 'País',
      city: 'Ciudad',
      pizzaType: 'Tipo de Pizza',
      ovenType: 'Tipo de Horno',
      experience: 'Experiencia Requerida',
      salary: 'Rango Salarial',
      accommodation: 'Alojamiento Disponible',
      urgency: 'Urgencia',
      notes: 'Notas',
      submit: 'Enviar',
      success: '¡Solicitud enviada con éxito!',
      error: 'Error durante el envío'
    },
    footer: {
      tagline: 'La red internacional de pizzeros profesionales',
      quickLinks: 'Enlaces Rápidos',
      contact: 'Contacto',
      legal: 'Legal',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Servicio',
      rights: 'Todos los derechos reservados'
    },
    experienceLevels: {
      '0-1': 'Principiante (0-1 años)',
      '1-2': 'Junior (1-2 años)',
      '2-5': 'Intermedio (2-5 años)',
      '5-10': 'Experto (5-10 años)',
      '10+': 'Maestro (10+ años)'
    },
    pizzaTypes: {
      napoletana: 'Napolitana',
      romana: 'Romana',
      contemporanea: 'Contemporánea',
      teglia: 'Teglia',
      pinsa: 'Pinsa'
    },
    ovenTypes: {
      legna: 'Horno de Leña',
      gas: 'Horno de Gas',
      elettrico: 'Horno Eléctrico',
      misto: 'Horno Mixto'
    },
    urgencyLevels: {
      immediate: 'Inmediata',
      '1month': 'En 1 mes',
      '3months': 'En 3 meses',
      flexible: 'Flexible'
    },
    countries: {
      all_europe: 'Toda Europa',
      italy: 'Italia',
      france: 'Francia',
      germany: 'Alemania',
      switzerland: 'Suiza',
      spain: 'España',
      uk: 'Reino Unido',
      netherlands: 'Países Bajos',
      belgium: 'Bélgica',
      austria: 'Austria',
      sweden: 'Suecia'
    },
    languages: {
      italian: 'Italiano',
      english: 'Inglés',
      french: 'Francés',
      spanish: 'Español',
      german: 'Alemán',
      portuguese: 'Portugués'
    }
  }
};
